import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["input", "isReadOnly", "isDisabled", "isRequired", "label", "helperText", "description", "validateOnMount", "meta", "FormFieldGridProps", "FormControlProps", "FormGroupProps", "FormControlLabelProps", "CheckboxProps", "FormLabelProps", "FormHelperTextProps", "inputProps"],
    _excluded2 = ["options"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import MUICheckbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import FormGroup from "@mui/material/FormGroup";
import FormLabel from "@mui/material/FormLabel";
import { meta, input } from '@data-driven-forms/common/prop-types-templates';
import FormFieldGrid from '../form-field-grid/form-field-grid';
import { validationError } from '../validation-error/validation-error';
import MultipleChoiceList from '../multiple-chioce-list/multiple-choice-list';
import useFieldApi from "@data-driven-forms/react-form-renderer/use-field-api";
export var SingleCheckbox = function SingleCheckbox(props) {
  var _useFieldApi = useFieldApi(_objectSpread(_objectSpread({}, props), {}, {
    type: 'checkbox'
  })),
      input = _useFieldApi.input,
      isReadOnly = _useFieldApi.isReadOnly,
      isDisabled = _useFieldApi.isDisabled,
      isRequired = _useFieldApi.isRequired,
      label = _useFieldApi.label,
      helperText = _useFieldApi.helperText,
      description = _useFieldApi.description,
      validateOnMount = _useFieldApi.validateOnMount,
      meta = _useFieldApi.meta,
      FormFieldGridProps = _useFieldApi.FormFieldGridProps,
      FormControlProps = _useFieldApi.FormControlProps,
      FormGroupProps = _useFieldApi.FormGroupProps,
      FormControlLabelProps = _useFieldApi.FormControlLabelProps,
      CheckboxProps = _useFieldApi.CheckboxProps,
      FormLabelProps = _useFieldApi.FormLabelProps,
      FormHelperTextProps = _useFieldApi.FormHelperTextProps,
      inputProps = _useFieldApi.inputProps,
      rest = _objectWithoutProperties(_useFieldApi, _excluded);

  var invalid = validationError(meta, validateOnMount);
  var text = invalid || (meta.touched || validateOnMount) && meta.warning || helperText || description;
  return /*#__PURE__*/React.createElement(FormFieldGrid, FormFieldGridProps, /*#__PURE__*/React.createElement(FormControl, _extends({
    required: isRequired,
    error: !!invalid,
    component: "fieldset"
  }, FormControlProps), /*#__PURE__*/React.createElement(FormGroup, FormGroupProps, /*#__PURE__*/React.createElement(FormControlLabel, _extends({}, FormControlLabelProps, {
    control: /*#__PURE__*/React.createElement(MUICheckbox, _extends({}, input, CheckboxProps, {
      disabled: isDisabled || isReadOnly,
      value: input.name,
      inputProps: _objectSpread({
        readOnly: isReadOnly
      }, inputProps)
    }, rest)),
    disabled: isDisabled || isReadOnly,
    label: /*#__PURE__*/React.createElement(FormLabel, FormLabelProps, label)
  })), text && /*#__PURE__*/React.createElement(FormHelperText, FormHelperTextProps, text))));
};
SingleCheckbox.propTypes = {
  input: input,
  meta: meta,
  isReadOnly: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  label: PropTypes.node,
  helperText: PropTypes.node,
  description: PropTypes.node,
  validateOnMount: PropTypes.bool,
  FormFieldGridProps: PropTypes.object,
  FormControlProps: PropTypes.object,
  FormGroupProps: PropTypes.object,
  FormControlLabelProps: PropTypes.object,
  CheckboxProps: PropTypes.object,
  FormLabelProps: PropTypes.object,
  FormHelperTextProps: PropTypes.object
};
SingleCheckbox.defaultProps = {
  FormFieldGridProps: {},
  FormControlProps: {},
  FormGroupProps: {},
  FormControlLabelProps: {},
  CheckboxProps: {},
  FormLabelProps: {},
  FormHelperTextProps: {}
};

var Checkbox = function Checkbox(_ref) {
  var options = _ref.options,
      props = _objectWithoutProperties(_ref, _excluded2);

  return options ? /*#__PURE__*/React.createElement(MultipleChoiceList, _extends({
    options: options
  }, props)) : /*#__PURE__*/React.createElement(SingleCheckbox, props);
};

Checkbox.propTypes = {
  options: PropTypes.array
};
export default Checkbox;